import { useEffect } from "react";

// Типы как в AppSnackBar Flutter-приложения: error — оранжевая плашка,
// success — лаймовая. Автоматически закрывается через duration мс.
export function Snackbar({ children, onClose, duration = 4000, type = "error" }) {
  useEffect(() => {
    const timeout = setTimeout(onClose, duration);
    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const classes = ["ui-snackbar", type === "success" ? "ui-snackbar--success" : ""]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classes} onClick={onClose}>
      <div className="ui-snackbar__body">
        <span className="ui-snackbar__icon">
          {type === "success" ? (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1.2 14.5l-3.8-3.8 1.4-1.4 2.4 2.4 5.8-5.8 1.4 1.4-7.2 7.2z" />
            </svg>
          ) : (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
              <path d="M12 7.5v5.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              <circle cx="12" cy="16.4" r="1.2" fill="currentColor" />
            </svg>
          )}
        </span>
        <div className="ui-snackbar__content">{children}</div>
        {onClose && (
          <button
            type="button"
            className="ui-snackbar__close"
            onClick={(event) => {
              event.stopPropagation();
              onClose();
            }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path
                d="M6 6l12 12M18 6L6 18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
}
